export default {
  week: {
    hr: 'Week',
    en: 'Week'
  }
};
